const generateChartData = <T>(
    startTime: EpochTimeStamp,
    defaultValue: T,
    amountToGenerate: number,
    timeInterval: number
): { time: number; value: T }[] =>
    [...Array(amountToGenerate)].map((_, index) => ({
        time: startTime + timeInterval * index,
        value: defaultValue,
    }));

export default generateChartData;
